export const constants = {
  new: "Work",
  bio: "About",
  blog: "Ephemera"
};



// WEBPACK FOOTER //
// ./src/constants.js